import React, { ForwardedRef, RefObject, type JSX } from 'react'
import useUniqueId from '../../hooks/use-unique-id'
import { Checkbox as CheckBoxComponent, Label } from '../../atoms'
import classNames from 'classnames'
interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string | JSX.Element
  className?: string
  labelClassName?: string
  forwardRef?: ForwardedRef<HTMLInputElement>
  ['data-test-id']?: string
  indexRef?: RefObject<HTMLDivElement> | null | undefined
}

export const Checkbox = ({
  label,
  forwardRef,
  className = '',
  labelClassName = '',
  indexRef,
  ...props
}: CheckboxProps) => {
  const checkboxId = useUniqueId('checkbox')

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      props.onChange?.({
        ...e,
        target: { checked: !props.checked },
      } as unknown as React.ChangeEvent<HTMLInputElement>)
    }
  }

  return (
    <div ref={indexRef} className={classNames('c-checkbox', className)}>
      <CheckBoxComponent
        id={checkboxId}
        type="checkbox"
        name={props.name}
        forwardRef={forwardRef}
        value={props.value}
        checked={props.checked}
        disabled={props.disabled}
        onChange={props.onChange}
        onKeyDown={handleKeyDown}
        data-test-id={props['data-test-id']}
        readOnly
      />

      {label && (
        <Label id={checkboxId} className={labelClassName}>
          {label}
        </Label>
      )}
    </div>
  )
}

export default Checkbox
